import React from 'react';
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import {
    faTwitter,
    faGithub,
    faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import '../styles/Contacts.css';

export default function Contacts() {
    const year = new Date();
    return (
        <div className="content-bg my-5 p-2">
            <div className="pt-3">
                <img src="images/arabank.png" alt="logo" width="70" height="70" className="center-logo logo" />
                <div className="mx-auto m-5" style={{ width: "80%", height: "80%" }}>
                    <div className="container contact-container">
                        <div className="row justify-content-between align-items-center p-5">
                            <div className="more-info-1">
                                <div className="quote hidden-info my-3">
                                    <span className="title pb-4" style={{ color: "thistle" }}>Stacks</span>
                                    <div className="content">
                                        <span>HTML</span>
                                        <span className="mx-1">|</span>
                                        <span>CSS</span>
                                        <span className="mx-1">|</span>
                                        <span>ES6</span>
                                        <span className="mx-1">|</span>
                                        <span>React.js</span>
                                        <span className="mx-1">|</span>
                                        <br />
                                        <span>React-Native</span>
                                        <span className="mx-1">|</span>
                                        <span>Graphql</span>
                                        <span className="mx-1">|</span>
                                        <span>Material-UI</span>
                                    </div>
                                </div>
                                <div className="contact-info my-3">
                                    <span className="title pb-4" style={{ color: "thistle" }}>Email</span>
                                    <div className="content my-2 text-white">
                                        <Link
                                            className="text-white"
                                            to={"mailto:oleariyah@gmail.com"}
                                            target="_blank"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                window.open("mailto:oleariyah@gmail.com");
                                            }}>
                                            <FontAwesomeIcon icon={faEnvelope} size="sm" className="mr-2" />
                                            oleariyah@gmail.com
                                        </Link>
                                    </div>
                                </div>
                                <div className="contact-info my-3">
                                    <span className="title pb-4" style={{ color: "thistle" }}>Phone</span>
                                    <div className="content my-2">
                                        <Link
                                            className="text-white"
                                            to={"tel:+234 901-958-4870"}
                                            target="_blank"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                window.open("tel:+234 (0) 701 070 0837");
                                            }}>
                                            <FontAwesomeIcon icon={faPhone} size="sm" className="mr-2" />
                                            +234 (0) 701 070 0837
                                        </Link>
                                    </div>
                                    <div className="content my-2">
                                        <Link
                                            className="text-white"
                                            to={"tel:+234 (0) 810 802 5201"}
                                            target="_blank"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                window.open("tel:+234 (0) 810 802 5201");
                                            }}>
                                            <FontAwesomeIcon icon={faPhone} size="sm" className="mr-2" />
                                            +234 (0) 810 802 5201
                                         </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="vl mt-2"></div>
                            <div className="more-info-2">
                                <div className="quote  my-3">
                                    <span className="title pb-4" style={{ color: "thistle" }}>Stacks</span>
                                    <div className="content">
                                        <span>HTML</span>
                                        <span className="mx-1">|</span>
                                        <span>CSS</span>
                                        <span className="mx-1">|</span>
                                        <span>ES6</span>
                                        <span className="mx-1">|</span>
                                        <span>React.js</span>
                                        <span className="mx-1">|</span>
                                        <br />
                                        <span>React-Native</span>
                                        <span className="mx-1">|</span>
                                        <span>Graphql</span>
                                        <span className="mx-1">|</span>
                                        <span>Material-UI</span>
                                    </div>
                                </div>
                                <div className="quote my-3 h2 text-center font-italic">
                                    "I design and develop experiences that make people's lives
                                    <span style={{ color: "gold" }}> simple.</span>"
                                </div>
                                <div className="py-3 text-center" style={{ color: "grey" }}>
                                    © {year.getFullYear()} Portfolio. All Rights Reserved.
                                <br />
                                Created by Olaiya Sodiq Abiola.
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
                <div className="p-5">
                    <div className="icons">
                        <div className="d-flex flex-column">
                            <Link
                                className="text-white"
                                to={"https://github.com/Oleariyah"}
                                target="_blank"
                                onClick={(e) => {
                                    e.preventDefault();
                                    window.open("https://github.com/Oleariyah");
                                }}>
                                <FontAwesomeIcon icon={faGithub} size="lg" className="my-3" />
                            </Link>
                            <Link
                                className="text-white"
                                to={"https://www.linkedin.com/in/oleariyah/"}
                                target="_blank"
                                onClick={(e) => {
                                    e.preventDefault();
                                    window.open("https://www.linkedin.com/in/oleariyah/");
                                }}>
                                <FontAwesomeIcon icon={faLinkedin} size="lg" className="my-3" />
                            </Link>
                            <Link
                                className="text-white"
                                to={"https://twitter.com/oleariyah"}
                                target="_blank"
                                onClick={(e) => {
                                    e.preventDefault();
                                    window.open("https://twitter.com/oleariyah");
                                }}>
                                <FontAwesomeIcon icon={faTwitter} size="lg" className="my-3" />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
